import React,{useEffect, useState} from "react";
import backgroundImage from '../Assets/background.png'; 
import PuffLoader from "react-spinners/PuffLoader";



const TermsConditions = () => {
  const [loading, setLoading] = useState(true); // Loading state
  useEffect(() => {
    // Simulate data fetching or delay for loader
    const timer = setTimeout(() => {
      setLoading(false); // Stop loading after 3 seconds
    }, 3000);

    return () => clearTimeout(timer); // Cleanup timeout
  }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);



  return (
    <div className='mainpage'>
   {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <PuffLoader color="#D0C743" size={100} />
        </div>
      ) : (
        <>
      
      
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '20px',
        color: '#333',
      }}
    >

      <h1 className="cancellation-policy-title">
        Terms & Conditions
      </h1>
</div>
     <div className="terms-container">
        <p>
          For the purpose of these Terms and Conditions, the term "we", "us",
          "our" used anywhere on this page shall mean Pravitha Jewels, whose
          registered/operational office is B-109, Oracle Residency, 3rd Main
          Road, Hoysala Nagar, Horamavu, Bengaluru, Karnataka, 560043. "You",
          "your", "user", "visitor" shall mean any natural or legal person who
          is visiting our website or agreed to purchase from us.
        </p>
        <p>Your use of the website and/or purchase from us are governed by the following Terms and Conditions:</p>
        <ul>
          <li>The content of the pages of this website is subject to change without notice.</li>
          <li>
          Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or 
          suitability of the information and materials found or offered on this website for any particular purpose. 
          You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for 
          any such inaccuracies or errors to the fullest extent permitted by law.
          </li>
          <li>
          Your use of any information or materials on our website and/or product pages is entirely at your own risk, 
          for which we shall not be liable. It shall be your own responsibility to ensure that any products, 
          services or information available through our website and/or product pages meet your specific requirements.
          </li>
          <li>
          Our website contains material which is owned by or licensed to us. This material includes, but are not limited to, the design, layout, look, 
          appearance and graphics. Reproduction is prohibited other than in 
          accordance with the copyright notice, which forms part of these terms and conditions.
          </li>
          <li>
          All trademarks reproduced in our website which are not the property of, or licensed to, the operator are acknowledged on the website.
          </li>
          <li>
            Unauthorized use of information provided by us shall give rise to a
            claim for damages and/or be a criminal offense.
          </li>
          <li>
            From time to time, this website may also include links to other
            websites. These links are provided for your convenience to provide
            further information.
          </li>
          <li>
            You may not create a link to our website from another website or
            document without Pravitha Jewels's prior written consent.
          </li>
          <li>
            Any dispute arising out of or related to our website and/or
            purchase with us shall be subject to the laws of India.
          </li>
          <li>
          We, shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of 
          authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time
          </li>
        </ul>
        <p>
          <strong>Disclaimer:</strong> The above content is created at
          Pravitha Jewels's sole discretion. Razorpay shall not be liable for
          any content provided here and shall not be responsible for any claims
          and liability that may arise due to merchant’s non-adherence to it.
        </p>
      </div>
      </>
      )}
      </div>
    
  );
};

export default TermsConditions;
